/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["filter-controls .input-container{max-width:120px}filter-controls .input-container label{display:none}"];
export { styles as styles };
